export const CSV_SUCCESS_MESSAGE = 'CSVを出力しました。';
export const CSV_ERROR_MESSAGE = 'CSVの出力に失敗しました。';
export const EMPTY_TEXT_FILTERED = '該当する検索結果がありません。';

export const UPDATE_SUCCESS_MESSAGE = '更新が正常に終了しました。';
export const UPDATE_ERROR_MESSAGE = '更新ができませんでした。';
export const DELETE_SUCCESS_MESSAGE = '削除しました。';
export const DELETE_COMPLETED_MESSAGE = '削除が正常に終了しました。';
export const DELETE_ERROR_MESSAGE = '削除に失敗しました。';
export const DELETE_CONFIRM_DATA_MESSAGE = 'このデータを削除してよろしいですか？';
export const PDF_ERROR_MESSAGE = 'PDFの生成に失敗しました。';
/** A tab the browser refused to open. Same sentence `useRezeptIssue` already shows. */
export const POPUP_BLOCKED_MESSAGE =
  'ポップアップがブロックされました。ブラウザの設定を確認してください。';

export const UPLOAD_SUCCESS_MESSAGE = 'アップロードしました。';
export const UPLOAD_ERROR_MESSAGE = 'アップロードに失敗しました。';
export const DOWNLOAD_ERROR_MESSAGE = 'ダウンロードに失敗しました。';
export const FILE_FETCH_ERROR_MESSAGE = 'ファイルの取得に失敗しました。';

export const SERVER_ERROR_MESSAGE = 'エラーが発生しました。しばらくしてからもう一度お試しください。';

/**
 * 既読にする pressed on a row the list still draws as 未読, but which something else has since read.
 *
 * ONE SENTENCE FOR BOTH PORTALS. The admin screen reaches it through a 409 (SyncNotificationController's
 * MARK_READ_CONFLICT_MESSAGE, one id per request); the clinic screen reaches it through a bulk 200 that
 * moved no rows. Different mechanisms, same thing to tell the reader — so the wording lives here rather
 * than being spelled out at each call site, where the two would drift.
 *
 * NOT the same as 「選択した通知はすべて既読です。」, which answers a DIFFERENT question: there the reader
 * deliberately ticked rows already showing 既読, and nothing is stale. Telling them to reload would be
 * noise. The two are chosen by whether the selection contained a row drawn as 未読.
 */
export const NOTIFICATION_MARK_READ_CONFLICT_MESSAGE =
  '対象の通知は既に更新されています。画面を再読み込みしてください。';

/** Every ticked row was already 既読 when it was ticked — the ordinary case, not a stale list. */
export const NOTIFICATION_ALL_ALREADY_READ_MESSAGE = '選択した通知はすべて既読です。';
